import {ICookiesService} from "./cookies.service.interface";

export class CookiesService implements ICookiesService {
    createCookie(name: string, value: string, expiration_date?:Date): void {
        let expirationDate;
        if (expiration_date) {
            expirationDate = expiration_date.toUTCString()
        } else {
            let now = new Date();
            now.setFullYear(now.getFullYear() + 1);
            expirationDate = now.toUTCString();
        }
        document.cookie = name + '=' + value + ';expires=' + expirationDate+ ';path=/';
    }

    createDomainCookie(name: string, value: string): void {
        let now = new Date();
        now.setFullYear(now.getFullYear() + 1);
        document.cookie = name + '=' + value + ';domain=.888casino.com;expires=' + now.toUTCString() + ';path=/';
    }

    getCookie(name: string) {
        let match = document.cookie.match(new RegExp(name + '=([^;]+)'));
        if (match) {
            return match[1];
        }
    }

    removeCookie(name: string): void {
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;domain=.888casino.com;";
    }
}